import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import SeVerLetterNew from "../../components/services/secondaryEducation/SeVerLetterNew";

const SEVerLetterNewPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.new`)}>
      <SeVerLetterNew />
    </PageWrapper>
  );
};

export default SEVerLetterNewPage;
